{
  "shellSkipMenuMainContent": "Accéder directement au contenu principal"
}
